import AxiosClient from '@/api/client';
import { API_BASE_URL } from '@/config/constants';

/**
 * Export template standards as Excel
 * @param propertyTypeId - Property Type ID (e.g., "1" for Hotels)
 * @param filters - Optional filters (search, department_id, touchpoint_id, sub_touchpoint_id, title_id)
 */
export async function exportTemplateStandardsExcel(
  propertyTypeId: string,
  filters?: {
    search?: string;
    department_id?: number;
    touchpoint_id?: number;
    sub_touchpoint_id?: number;
    title_id?: number;
  }
): Promise<void> {
  try {
    // Build query parameters
    const params = new URLSearchParams();
    if (filters?.search) params.append('search', filters.search);
    if (filters?.department_id)
      params.append('department_id', filters.department_id.toString());
    if (filters?.touchpoint_id)
      params.append('touchpoint_id', filters.touchpoint_id.toString());
    if (filters?.sub_touchpoint_id)
      params.append('sub_touchpoint_id', filters.sub_touchpoint_id.toString());
    if (filters?.title_id)
      params.append('title_id', filters.title_id.toString());

    const queryString = params.toString();
    const endpoint = `/property-types/${propertyTypeId}/standards/export-excel${queryString ? `?${queryString}` : ''}`;

    // Create AxiosClient with token support
    const client = new AxiosClient({
      endpoint: endpoint,
      contentType: 'application/json',
      isToken: true,
      baseURL: API_BASE_URL,
    });

    // Make request using AxiosClient instance with the endpoint
    const response = await client.instance.get(endpoint, {
      responseType: 'blob', // Important for file download
      headers: {
        Accept:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
    });

    // Download file
    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = `template-standards-${propertyTypeId}-${new Date().toISOString().split('T')[0]}.xlsx`;
    document.body.appendChild(a);
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
  } catch (error) {
    console.error('[Export] Excel export failed:', error);
    throw error;
  }
}
